/**
 * The reasons a place or an offer ends, as the release dialogs list them and
 * the coordinators' screens word them. The server owns the codes and checks
 * them against the side that gives them; the words here are the ones its
 * emails use.
 */
export const STUDENT_END_REASONS = Object.freeze([
    'other_job_or_hours',
    'schedule_conflict',
    'personal_or_family',
    'accepted_another',
    'no_longer_eligible',
    'other',
]);

export const REVIEWER_END_REASONS = Object.freeze([
    'unresponsive',
    'no_longer_eligible',
    'course_changed_or_cancelled',
    'not_right_fit',
    'student_request',
    'other',
]);

export const END_REASON_WORDS = Object.freeze({
    student: Object.freeze({
        other_job_or_hours: 'Another campus job, or too many hours',
        schedule_conflict: 'Schedule conflict',
        personal_or_family: 'Personal or family circumstances',
        accepted_another: 'Accepted another position',
        no_longer_eligible: 'No longer meet the eligibility requirements',
        other: 'Other',
    }),
    reviewer: Object.freeze({
        unresponsive: 'Student unresponsive',
        no_longer_eligible: 'Student no longer eligible',
        course_changed_or_cancelled: 'Course changed or cancelled',
        not_right_fit: 'Not the right fit',
        student_request: "At the student's request",
        other: 'Other',
    }),
});

export const END_REASON_TEXT_MAX = 1000;

const GIVEN_BY_WORDS = Object.freeze({
    student: 'the student',
    faculty: 'faculty',
    coordinator: 'a coordinator',
    admin: 'an admin',
});

/** The words for a code on a side ('student' or 'reviewer'), else the code. */
export function endReasonWords(code, side) {
    return END_REASON_WORDS[side]?.[code] || String(code);
}

/** Who gave a recorded reason, from the role stored with it. */
export function givenByWords(byRole) {
    return GIVEN_BY_WORDS[byRole] || 'a reviewer';
}

/** The side a recorded actor role belongs to. */
export const sideOfRole = (byRole) =>
    byRole === 'student' ? 'student' : 'reviewer';
